import { createContext, useContext, useState } from 'react';

interface LoginRedirectContextState {
	redirectUrl: string | null;
	setRedirectUrl: React.Dispatch<React.SetStateAction<string | null>>;
	setRedirectUrlTimeout: (value: string | null) => void;
}

const LoginRedirectContext = createContext<LoginRedirectContextState | undefined>(undefined);

export const LoginRedirectProvider = ({ children }: { children: React.ReactNode }) => {
	const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
	const setRedirectUrlTimeout = (value: string | null) =>
		setTimeout(() => setRedirectUrl(value), 0);
	return (
		<LoginRedirectContext.Provider
			value={{ redirectUrl, setRedirectUrl, setRedirectUrlTimeout }}>
			{children}
		</LoginRedirectContext.Provider>
	);
};

export const useLoginRedirect = () => {
	const value = useContext(LoginRedirectContext);
	if (value === undefined)
		throw new Error('useLoginRedirect must be used inside a LoginRedirectProvider');
	return value;
};
